import { render } from "./accountLock.vue?vue&type=template&id=824852fe"
const script = {}
script.render = render

export default script